export const TIME_SLOTS_BY_DATES = {
  "2025-11-05": ["12:00 PM - Granite City Lumberjacks"],
};

export const RACE_OPTIONS = [
  "American Indian or Alaska Native",
  "Asian",
  "Black or African American",
  "Native Hawaiian or other Pacific Islander",
  "Other Race",
  "White",
];

export const ETHNICITY_OPTIONS = [
  "Central American",
  "Cuban",
  "Dominican",
  "Hispanic or Latino",
  "Latin American",
  "Mexican",
  "Not Hispanic or Latino",
  "Puerto Rican",
  "South American",
  "Spaniard",
];

export const LANGUAGE_OPTIONS = ["English", "Spanish; Castilian"];

export const MARITAL_STATUS_OPTIONS = [
  "UNKNOWN",
  "MARRIED",
  "SINGLE",
  "DIVORCED",
  "SEPARATED",
  "WIDOWED",
  "PARTNER",
];

export const RELATIONSHIP_OPTIONS = [
  "Self",
  "Child",
  "Significant other",
  "Stepson",
  "Stepdaughter",
  "Sibling",
  "Ward",
  "Parent",
  "Spouse",
];
